export default __webpack_public_path__ + "static/media/menu.28750947.svg";